module.exports = __webpack_public_path__ + "img/notifi-error.8640f64d.svg";